import React, { useState, useEffect } from "react";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";
import SwipeableViews from "react-swipeable-views";
import MobileStepper from "@mui/material/MobileStepper";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import Languages from "../../../translations";

const ReadOnlyBox = ({ label, bgColor, children }) => (
  <Box
    sx={{
      backgroundColor: bgColor,
      borderRadius: 2,
      boxShadow: 1,
      mt: 2,
      pt: 2,
      pb: 2,
      px: 1,
    }}
  >
    {label ? (
      <Typography
        sx={{
          fontWeight: "bold",
          fontSize: 14,
          color: "#424242",
          ml: 1,
          mb: 1,
        }}
      >
        {label}
      </Typography>
    ) : null}
    {children}
  </Box>
);

const ReadOnlyEntry = ({ value, saved }) => (
  <Box>
    <Typography
      variant="body1"
      sx={{
        whiteSpace: "pre-wrap",
        color: value ? "black" : "#464646",
        minHeight: 24,
        px: 1,
        pb: 0.5,
      }}
    >
      {value || Languages.NoEntriesYet}
    </Typography>
    {saved && (
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", textAlign: "left", px: 1 }}
      >
        {saved}
      </Typography>
    )}
  </Box>
);

const DiscussionDetail = ({ items, SelectedSlideIndex, sectionTitle }) => {
  const list = items || [];
  const MaxSlideCount = list.length;

  const [SlideIndex, setSlideIndex] = useState(SelectedSlideIndex ?? 0);

  useEffect(() => {
    setSlideIndex(SelectedSlideIndex ?? 0);
  }, [SelectedSlideIndex]);

  if (MaxSlideCount === 0) return null;
  const item = list[SlideIndex];
  if (!item) return null;
  const currentSectionTitle = item.SectionTitle || sectionTitle;

  const headerColor = (it) => "#afdfc8";

  const handleChangeIndex = (index) => setSlideIndex(index);
  const handlePrev = () => {
    if (SlideIndex > 0) setSlideIndex(SlideIndex - 1);
  };
  const handleNext = () => {
    if (SlideIndex < MaxSlideCount - 1) setSlideIndex(SlideIndex + 1);
  };

  return (
    <div className="CombinedPlanDiscussionDetail">
      <Box>
        <SwipeableViews
          className={"col-12 textCenter slide pt-3"}
          index={SlideIndex}
          key={SlideIndex}
          onChangeIndex={handleChangeIndex}
        >
          {list.map((it, index) => (
            <div key={index}>
              <Box
                className="br-top col-12"
                sx={{ backgroundColor: headerColor(it) }}
              >
                <Typography
                  color="textSecondary"
                  sx={{
                    textAlign: "center",
                    fontWeight: "Bold",
                    fontSize: 18,
                    color: "#424242",
                    pt: 1,
                  }}
                >
                  {it.SectionTitle || sectionTitle}
                </Typography>
                <MobileStepper
                  style={{
                    backgroundColor: headerColor(it),
                    color: "black",
                    padding: 0,
                  }}
                  variant="text"
                  steps={MaxSlideCount}
                  position="static"
                  activeStep={SlideIndex}
                  nextButton={
                    <Button
                      size="small"
                      style={{
                        color: "black",
                        opacity: SlideIndex === MaxSlideCount - 1 ? "0.5" : "",
                      }}
                      onClick={handleNext}
                      disabled={SlideIndex === MaxSlideCount - 1}
                    >
                      {Languages.next} <KeyboardArrowRight />
                    </Button>
                  }
                  backButton={
                    <Button
                      size="small"
                      style={{
                        color: "black",
                        opacity: SlideIndex === 0 ? "0.5" : "",
                      }}
                      onClick={handlePrev}
                      disabled={SlideIndex === 0}
                    >
                      <KeyboardArrowLeft /> {Languages.prev}
                    </Button>
                  }
                />
              </Box>
              <Box
                className="br-btm col-12"
                sx={{ boxShadow: 2, mb: 3, pb: 1, backgroundColor: "white" }}
              >
                <Typography
                  color="textSecondary"
                  sx={{
                    textAlign: "center",
                    fontWeight: "Medium",
                    fontSize: 16,
                    color: "#424242",
                    pt: 1,
                  }}
                >
                  {it.Label}
                </Typography>
              </Box>
            </div>
          ))}
        </SwipeableViews>

        <Box sx={{ px: 1 }}>
          <Divider textAlign="left">
            <Chip
              label={
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontSize: 14,
                    color: "#424242",
                  }}
                >
                  {Languages.StaffNotes}
                </Typography>
              }
              variant="outlined"
            />
          </Divider>
          <ReadOnlyBox bgColor="#afdfc8">
            <ReadOnlyEntry value={item.MainText} saved={item.MainTextSaved} />
          </ReadOnlyBox>

          {item.Evaluations && item.Evaluations.length > 0 && (
            <>
              <Divider textAlign="left" sx={{ mt: 2 }}>
                <Chip
                  label={
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        fontSize: 14,
                        color: "#424242",
                      }}
                    >
                      {Languages.Evaluation}
                    </Typography>
                  }
                  variant="outlined"
                />
              </Divider>
              {item.Evaluations.map((evaluation, idx) => (
                <ReadOnlyBox key={idx} bgColor="#afdfc8">
                  <ReadOnlyEntry
                    value={evaluation.Text}
                    saved={evaluation.Saved}
                  />
                </ReadOnlyBox>
              ))}
            </>
          )}
        </Box>
      </Box>
    </div>
  );
};

export default DiscussionDetail;
